export function formatTotal (total) {
  return `${total.toLocaleString()} lbs`; 
}


// WEBPACK FOOTER //
// ./src/helpers.js